package pl.zar.tikthrow.ui.media

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.get
import pl.zar.tikthrow.viewmodel.ContentType

@Composable
actual fun rememberMediaPickerState(
    contentType: ContentType?,
    onSelected: (List<MediaItem>) -> Unit
): MediaPickerState {
    val selected = remember { mutableStateListOf<MediaItem>() }
    return MediaPickerState(
        selectedMedia = selected.toList(),
        launch = {
            val input = document.createElement("input") as HTMLInputElement
            input.type = "file"
            input.multiple = true
            input.accept = when (contentType) {
                ContentType.POST -> "image/*"
                ContentType.SHORTS, ContentType.VIDEO -> "video/*"
                null -> "image/*,video/*"
            }
            input.onchange = {
                val files = input.files
                if (files != null) {
                    val items = (0 until files.length).mapNotNull { index ->
                        val file = files[index] ?: return@mapNotNull null
                        val uri = js("URL.createObjectURL(file)") as String
                        MediaFileRegistry.register(uri, file)
                        MediaItem(
                            uri = uri,
                            isVideo = file.type.startsWith("video/"),
                            fileName = file.name,
                            mimeType = file.type
                        )
                    }
                    selected.addAll(items)
                    onSelected(items)
                }
                null
            }
            input.click()
        }
    )
}
